<template>
  <div class="">
    <c-upload v-model="form.attachPath"></c-upload>
    <c-upload v-model="form.aa" @change="change1"></c-upload>

    <a-form-model ref="ruleForm" :model="form">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item
            :label-col="{ span: 12 }"
            :wrapper-col="{ span: 12 }"
            ref="titleFilePath"
            prop="titleFilePath"
            label="职称证书"
            :rules="{ required: true, message: '职称证书不能为空', trigger: 'change' }"
          >
            <a-upload
              name="upfile"
              v-model="form.titleFilePath"
              :action="uploadPhotUrl"
              :data="uploadData"
              :before-upload="beforeUpload"
              :file-list="titleFilePath.fileList"
              @change="handleChange(...arguments, 'titleFilePath')"
            >
              <a-button> <a-icon type="upload" />上传职称证书</a-button>
            </a-upload>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item
            ref="college"
            prop="college"
            label="毕业院校"
            :rules="{ required: true, message: '毕业院校不能为空', trigger: 'change' }"
          >
            <a-input placeholder="请填写毕业院校" v-model="form.college" @submit="aa" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-button type="primary" icon="search" @click="handleSubmit">提交</a-button>
    </a-form-model>
  </div>
</template>

<script>
import CUpload from '@/components/cusComponent/CUpload'
export default {
  components: {
    CUpload
  },
  data() {
    return {
      form: {
        attachPath: {},
        aa: {},
        college: 'aa',
        titleFilePath: ''
      },
      uploadData: {},
      titleFilePath: {
        fileList: [],
        loading: false
      }
    }
  },
  computed: {
    uploadPhotUrl: function () {
      return `${window._CONFIG['domianURL']}/uploader`
    }
  },

  methods: {
    change1(res) {
      console.log('--->', JSON.stringify(res, null, 2))
      this.form.attachPath = res.fileList
    },
    aa(val) {
      console.log('--->', val)
    },
    /* 文件上传 */
    handleChange(info, type) {
      if (info.file.status === 'done') {
        let res = info.file.response.result
        /*提交的数据*/
        type == 'titleFilePath' ? (this.form.titleFilePath = res) : ''
        type == 'diplomaFilePath' ? (this.form.diplomaFilePath = res) : ''
        type == 'expertFilePath' ? (this.form.expertFilePath = res) : ''
      }
      type == 'titleFilePath' ? (this.titleFilePath.fileList = info.fileList.slice(-1)) : []
      type == 'diplomaFilePath' ? (this.diplomaFilePath.fileList = info.fileList.slice(-1)) : []
      type == 'expertFilePath' ? (this.expertFilePath.fileList = info.fileList.slice(-1)) : []
    },
    beforeUpload(file) {
      this.uploadData = {
        filename: file.name
      }
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid, values) => {
        console.log(JSON.stringify(valid, null, 2))
        console.log(JSON.stringify(values, null, 2))
        if (valid) {
          let formData = Object.assign(this.form)
          console.log(JSON.stringify(formData, null, 2))
          // return false;
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
